import React from 'react';
import './Pages.css';

export default function Portfolio() {
  const projects = [
    {
      id: 1,
      title: 'E-Commerce Platform',
      category: 'Web Development',
      description: 'Complete redesign and implementation of a full-featured e-commerce platform.'
    },
    {
      id: 2,
      title: 'Mobile App Development',
      category: 'Mobile',
      description: 'Native mobile application with real-time synchronization features.'
    },
    {
      id: 3,
      title: 'Cloud Migration',
      category: 'Infrastructure',
      description: 'Enterprise-level cloud infrastructure migration with zero downtime.'
    },
    {
      id: 4,
      title: 'Analytics Dashboard',
      category: 'Data Visualization',
      description: 'Interactive dashboard for real-time business analytics and reporting.'
    },
    {
      id: 5,
      title: 'Brand Identity',
      category: 'Design',
      description: 'Complete brand overhaul including logo and design guidelines.'
    },
    {
      id: 6,
      title: 'API Development',
      category: 'Backend',
      description: 'RESTful API development with comprehensive documentation.'
    }
  ];

  return (
    <main className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1>Our Portfolio</h1>
          <p>Explore our recent projects and accomplishments</p>
        </div>
      </section>

      <section className="container page-section">
        <div className="portfolio-grid">
          {projects.map(project => (
            <div key={project.id} className="portfolio-card">
              <div className="project-image"></div>
              <p className="project-category">{project.category}</p>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <a href="/" className="project-link">View Case Study →</a>
            </div>
          ))}
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat">
              <h3>100+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat">
              <h3>50+</h3>
              <p>Happy Clients</p>
            </div>
            <div className="stat">
              <h3>15+</h3>
              <p>Years Experience</p>
            </div>
            <div className="stat">
              <h3>A+</h3>
              <p>Client Satisfaction</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
